/* eslint-disable */

import type { BackOfficeLang } from "./types/BackOfficeLang";

let data: BackOfficeLang | undefined;

export type { BackOfficeLang };

export default function BackOfficeLangFactory(): BackOfficeLang {
  if (!data) {
    throw new Error("Trying to load a language in the main bundle before the language bundle is loaded");
  }
  return data;
}

export let setBackOfficeLang = (newLang: string) => {
  if (newLang === "en-GB") {
      return import(/* webpackChunkName: "en-GB.locale" */ "./en-GB/BackOfficeLangDef").then(({ BackOfficeLangDef }) => {
      data = BackOfficeLangDef;
    });
  } else if (newLang === "sv-SE") {
      return import(/* webpackChunkName: "sv-SE.locale" */ "./sv-SE/BackOfficeLangDef").then(({ BackOfficeLangDef }) => {
      data = BackOfficeLangDef;
    });
  } else if (newLang === "en-SE") {
      return import(/* webpackChunkName: "en-SE.locale" */ "./en-SE/BackOfficeLangDef").then(({ BackOfficeLangDef }) => {
      data = BackOfficeLangDef;
    });
  } else if (newLang === "ky-KG") {
      return import(/* webpackChunkName: "ky-KG.locale" */ "./ky-KG/BackOfficeLangDef").then(({ BackOfficeLangDef }) => {
      data = BackOfficeLangDef;
    });
  }
  else {
    throw new Error("Unsupported language/culture " + newLang);
  }
};

